import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { config } from '@/config';
import { ClubTable } from '@/components/dashboard/club/club-table';

export default function ClubPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Club | Dashboard | {config.site.name}</title>
      </Helmet>
      <Stack spacing={3}>
        <div>
          <Typography variant="h4">Quản Lý Câu Lạc Bộ</Typography>
        </div>
        <ClubTable />
      </Stack>
    </>
  );
}
